import React, { useRef } from 'react';
var VeltAutocompleteOptionDescription = function (props) {
    var field = props.field, userObject = props.userObject, userId = props.userId, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-option-description", { ref: ref, field: field, "user-object": userObject ? (typeof userObject === 'object' ? JSON.stringify(userObject) : userObject) : undefined, "user-id": userId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltAutocompleteOptionDescription;
